// import './styles.scss';
import { HTMLMotionProps, motion } from 'framer-motion';


interface MotionDivProps extends HTMLMotionProps<"div"> {
    children: React.ReactNode;
}

export const MotionDiv: React.FC<MotionDivProps> = ({
    children,
    initial = { opacity: 0, x: 40 },
    whileInView = { opacity: 1, x: 0 },
    viewport = { once: true, amount: 0.3 },
    transition = { duration: 0.6, ease: "easeOut" },
    ...props
}) => {
    return (
        <motion.div
            initial={initial}
            whileInView={whileInView}
            viewport={viewport}
            transition={transition}
            {...props}
        >
            {children}
        </motion.div>
    );
};

export default MotionDiv;

